import { render, staticRenderFns } from "./LayoutMain.vue?vue&type=template&id=36875c71&scoped=true"
import script from "./LayoutMain.vue?vue&type=script&lang=ts"
export * from "./LayoutMain.vue?vue&type=script&lang=ts"
import style0 from "./LayoutMain.vue?vue&type=style&index=0&id=36875c71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36875c71",
  null
  
)

export default component.exports